module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "info-message"
  }, [_vm._v("\n            Scroll evt. for at se alle felter\n        ")]), _vm._v(" "), (_vm.showEmailChooser) ? _c('div', {
    staticClass: "email-chooser"
  }, [_vm._v("\n            Send test e-mail til:\n            "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.default.email),
      expression: "$store.state.form.default.email"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.default.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.default, "email", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 0),
      expression: "currentStep === 0"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_vm._v("\n                     \n                ")]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 1;
      }
    }
  }, [_vm._v("\n                        Videre\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 1),
      expression: "currentStep === 1"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_vm._v("\n                     \n                ")]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [(_vm.$store.state.form.container.serial && _vm.$store.state.form.container.serial.length < 6 || _vm.$store.state.form.validatedContainer === null || _vm.$store.state.form.faucet.serial === null || _vm.$store.state.form.faucet.serial === '') ? _c('span', [_vm._v("\n                        Udfyld alle felter markeret med \""), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")]), _vm._v("\" for at gå videre \n                    ")]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.container.serial && _vm.$store.state.form.container.serial.length < 6 || _vm.$store.state.form.validatedContainer === null || _vm.$store.state.form.faucet.serial === null || _vm.$store.state.form.faucet.serial === ''
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 2
      }
    }
  }, [_vm._v("\n                        Videre\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(3), _vm._v("\n                        Serienummeret finder du på et mærkat på siden af beholderen. Hvis du er i tvivl, se\n                        "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showSerialHelper = !_vm.showSerialHelper
      }
    }
  }, [_vm._v("her")]), _vm._v(".\n                        "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSerialHelper),
      expression: "showSerialHelper"
    }],
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner",
    attrs: {
      "align": "center"
    }
  }, [_c('h4', [_vm._v("Sådan finder du dit serienummer")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%",
      "max-height": "240px",
      "object-fit": "contain"
    },
    attrs: {
      "src": "static/img/serienummer-beholder.png"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showSerialHelper = false
      }
    }
  }, [_vm._v("\n                                    Luk\n                                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.container.serial),
      expression: "$store.state.form.container.serial"
    }],
    staticClass: "form-control upc",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.container.serial)
    },
    on: {
      "keyup": function($event) {
        return _vm.validateSerial()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.container, "serial", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mts"
  }, [(_vm.$store.state.form.validatedContainer !== null && _vm.$store.state.form.container.serial.length > 5) ? _c('span', {
    staticClass: "green"
  }, [_vm._v("\n                                " + _vm._s(_vm.$store.state.form.validatedContainer.name) + "\n                            ")]) : _c('span', [(_vm.$store.state.form.container.serial && _vm.$store.state.form.container.serial.length > 0) ? _c('span', {
    staticClass: "red"
  }, [_vm._v("\n                                    " + _vm._s(_vm.faucetSerial ? 'Det ser ud til, at du er ved at indtaste serienummeret på din hane og ikke din beholder. Skriv venligst serienummeret på din beholder i dette felt for at gå videre.' : 'Intet match fundet') + "\n                                ")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(4), _vm._v("\n                        Du finder serienummeret på den sorte ledning fra armaturet. Hvis du er i tvivl, se\n                        "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showTapSerialHelper = !_vm.showTapSerialHelper
      }
    }
  }, [_vm._v("her")]), _vm._v(".\n                        "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTapSerialHelper),
      expression: "showTapSerialHelper"
    }],
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner",
    attrs: {
      "align": "center"
    }
  }, [_c('h4', [_vm._v("Sådan finder du dit serienummer")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-height": "240px",
      "width": "100%",
      "object-fit": "contain"
    },
    attrs: {
      "src": "static/img/serienummer-hane.png"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showTapSerialHelper = false
      }
    }
  }, [_vm._v("\n                                    Luk\n                                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.faucet.serial),
      expression: "$store.state.form.faucet.serial"
    }],
    staticClass: "form-control upc",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.faucet.serial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.faucet, "serial", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 2),
      expression: "currentStep === 2"
    }],
    staticClass: "step"
  }, [(_vm.showNordicChooser) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                        Twintaps eller single tap Nordic?\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                        Twintaps består af både en kogende vandhane og et almindeligt blandingsbatteri fra Quooker.\n                        Single tap er når du kun har en kogende vandhane fra Quooker.\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "choose"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.chooseNordic('Twintaps')
      }
    }
  }, [_vm._v("\n                            Twintaps\n                        ")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.chooseNordic('Single Tap')
      }
    }
  }, [_vm._v("\n                            Single tap\n                        ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 1
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbage\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.validatedFaucet === null
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 3;
        _vm.setPixel('Vaelg overflade')
      }
    }
  }, [(_vm.$store.state.form.validatedFaucet === null) ? _c('span', [_vm._v("\n                            Hane skal vælges\n                        ")]) : _c('span', [_vm._v("\n                            Videre\n                        ")]), _vm._v(" "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "faucets"
  }, _vm._l((_vm.sortedFaucets), function(faucet) {
    return _c('div', {
      key: faucet.title,
      staticClass: "faucet",
      class: {
        'selected': _vm.$store.state.form.validatedFaucet !== null && _vm.$store.state.form.validatedFaucet.title === faucet.title
      },
      on: {
        "click": function($event) {
          return _vm.validateFaucet(faucet)
        }
      }
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": faucet.image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v("\n                            " + _vm._s(faucet.title) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "description"
    }, [_vm._v("\n                            " + _vm._s(faucet.description) + "\n                        ")])])
  }), 0), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 3),
      expression: "currentStep === 3"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 2
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbage\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.faucet.surface === null
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 4;
        _vm.setPixel('Problem aarsag')
      }
    }
  }, [(_vm.$store.state.form.faucet.surface === null) ? _c('span', [_vm._v("\n                            Overflade skal vælges\n                        ")]) : _c('span', [_vm._v("\n                            Videre\n                        ")]), _vm._v(" "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "surfaces"
  }, _vm._l((_vm.sortedSurfaces), function(surface) {
    return _c('div', {
      key: surface.title,
      staticClass: "surface",
      class: {
        'selected': _vm.$store.state.form.faucet.surface === surface.title
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.faucet.surface = surface.title
        }
      }
    }, [_c('div', {
      staticClass: "image"
    }, [_c('img', {
      staticClass: "sm",
      attrs: {
        "src": surface.image
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v("\n                            " + _vm._s(surface.title) + "\n                        ")])])
  }), 0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 4),
      expression: "currentStep === 4"
    }],
    staticClass: "step"
  }, [(_vm.showRestartHelper) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.showRestartHelper = false
      }
    }
  }, [_vm._v("\n                        X\n                    ")]), _vm._v(" "), _c('h4', [_vm._v("\n                        Sådan nulstiller du din Quooker\n                    ")]), _vm._v("\n                    Mange fejl kan med succes afhjælpes, med en simpel genstart og nulstilling af softwaren i Quookeren.\n                    "), _c('a', {
    attrs: {
      "href": "https://quooker.dk/service/fejlguide/genstart-nulstil",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_vm._v("\n                        Se her hvordan du genstarter din Quooker korrekt")]), _vm._v(".\n                    "), _c('br'), _c('br'), _vm._v("\n                    Det er ikke nok bare at hive stikket ud!\n                    "), _c('br'), _c('br'), _vm._v("\n                    Vi anbefaler du prøver at genstarte din Quooker korrekt nogle gange, inden du kontakter os.\n                    "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "option",
    on: {
      "click": function($event) {
        _vm.showRestartHelper = false
      }
    }
  }, [_vm._v("\n                        Luk vindue\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.showBlinkHelper) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.showBlinkHelper = false;
        _vm.$store.state.form.problem.questions[2].answer = null
      }
    }
  }, [_vm._v("\n                        X\n                    ")]), _vm._v(" "), _c('h4', [_vm._v("\n                        Hvordan blinker din Quooker?\n                    ")]), _vm._v("\n                    Hvis Quookeren opdager en fejl/uregelmæssighed vil lyset i hanen og på beholderen blinke i et fast mønster.\n                    "), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "font-size": "90%"
    }
  }, [_vm._v("OBS! I nogle tilfælde er det kun beholderen der blinker, tjek derfor altid både hanen og beholderen.")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "option-wrapper"
  }, [_c('div', {
    staticClass: "option fl",
    on: {
      "click": function($event) {
        _vm.$store.state.form.problem.questions[2].extra = '2 blink';
        _vm.showBlinkHelper = false
      }
    }
  }, [_vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "option fl",
    on: {
      "click": function($event) {
        _vm.$store.state.form.problem.questions[2].extra = '4 blink';
        _vm.showBlinkHelper = false;
        _vm.show4BlinkHelper = true
      }
    }
  }, [_vm._m(8)]), _vm._v(" "), _c('div', {
    staticClass: "option fl",
    on: {
      "click": function($event) {
        _vm.$store.state.form.problem.questions[2].extra = '3 + 1 blink';
        _vm.showBlinkHelper = false
      }
    }
  }, [_vm._m(9)])]), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "option last",
    on: {
      "click": function($event) {
        _vm.$store.state.form.problem.questions[2].extra = 'Andet / ved ikke';
        _vm.showBlinkHelper = false
      }
    }
  }, [_vm._v("\n                            Andet / ved ikke\n                        ")])])])]) : _vm._e(), _vm._v(" "), (_vm.show4BlinkHelper) ? _c('div', {
    staticClass: "nordic-chooser"
  }, [_c('div', {
    staticClass: "inner",
    staticStyle: {
      "max-height": "90%",
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.show4BlinkHelper = false
      }
    }
  }, [_vm._v("\n                        X\n                    ")]), _vm._v(" "), _c('h4', [_vm._v("\n                        4 blink\n                    ")]), _vm._v("\n                    4 blink på hane, eller beholder, betyder at softwaren i din Quooker registrerer en fejl i forbindelse med temperaturmålingen i din Quooker.\n                    "), _c('br'), _c('br'), _vm._v(" "), _c('b', {
    staticStyle: {
      "color": "#C80236"
    }
  }, [_vm._v("Tips!")]), _c('br'), _vm._v("\n                    Fejlen kan ofte nulstilles, ved at give beholderen et \"kuldechok\""), _c('br'), _c('br'), _vm._v("\n                    Det gøres ved at slukke på beholderens top og tappe alt kogende vand af beholderen. Når vandet ikke længere er kogende, lader man vandet løbe i yderligere 2 minutter således at vandet er helt koldt."), _c('br'), _c('br'), _vm._v("\n                    Derefter skal du følge vores almindelige "), _c('a', {
    staticClass: "main",
    attrs: {
      "href": "https://quooker.dk/service/fejlguide/genstart-nulstil",
      "target": "_blank"
    }
  }, [_vm._v("nulstillingsprocedure")]), _vm._v(", hvorefter beholderen burde være klar til brug efter ca. 20 minutter."), _c('br'), _c('br'), _vm._v("\n                    Manøvren kan være nødvendig at gentage et par gange"), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticStyle: {
      "width": "unset",
      "outline": "none",
      "background": "#C80236",
      "color": "#fff",
      "border": "1px solid #e6003f!important",
      "padding": "5px 10px",
      "white-space": "nowrap"
    },
    on: {
      "click": function($event) {
        _vm.show4BlinkHelper = false
      }
    }
  }, [_vm._v("\n                        OK, det prøver jeg!\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 3
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbage\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.problem.questions[0].answer === null || _vm.$v.$store.state.form.problem.$invalid || _vm.$store.state.form.problem.questions[1].answer === null || _vm.$store.state.form.problem.questions[2].answer === null || _vm.$store.state.form.problem.description === null
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 5;
        _vm.setPixel('Garanti')
      }
    }
  }, [_vm._v("\n                        Videre\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._l((_vm.$store.state.form.problem.questions), function(question, index) {
    return _c('div', {
      key: question.question,
      staticClass: "line",
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_c('div', {
      staticClass: "left"
    }, [_c('label', [_vm._v("\n                            " + _vm._s(question.question) + "\n                        ")]), _vm._v(" "), (question.slug === 'restart') ? _c('div', [_vm._m(11, true)]) : _vm._e()]), _vm._v(" "), (index === 2) ? _c('div', {
      staticClass: "right flex"
    }, [_c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === true
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = true;
          _vm.showBlinkHelper = true
        }
      }
    }, [_vm._v("\n                            Ja\n                        ")]), _vm._v(" "), _c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === false
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = false;
          _vm.$store.state.form.problem.questions[index].extra = null
        }
      }
    }, [_vm._v("\n                            Nej\n                        ")])]) : (index === 3) ? _c('div', {
      staticClass: "right flex"
    }, [_c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === true
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = true
        }
      }
    }, [_vm._v("\n                            Ja\n                        ")]), _vm._v(" "), _c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === false
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = false;
          _vm.showRestartHelper = true
        }
      }
    }, [_vm._v("\n                            Nej\n                        ")])]) : _c('div', {
      staticClass: "right flex"
    }, [_c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === true
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = true
        }
      }
    }, [_vm._v("\n                            Ja\n                        ")]), _vm._v(" "), _c('button', {
      class: {
        'selected': _vm.$store.state.form.problem.questions[index].answer === false
      },
      on: {
        "click": function($event) {
          _vm.$store.state.form.problem.questions[index].answer = false
        }
      }
    }, [_vm._v("\n                            Nej\n                        ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.problem.description),
      expression: "$store.state.form.problem.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Beskrivelse af problem",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.$store.state.form.problem.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.problem, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-wrapper mts"
  }, [_c('validation-messages', {
    attrs: {
      "data": _vm.$v.$store.state.form.problem.description,
      "show": true
    }
  }), _vm._v(" "), (_vm.$store.state.form.problem.description) ? _c('div', {
    staticClass: "validator",
    class: {
      'validated': _vm.$store.state.form.problem.description.length > 19
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$store.state.form.problem.description.length) + " / 20\n                            ")]) : _vm._e()], 1)])])], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 5),
      expression: "currentStep === 5"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 4
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbage\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.$store.state.form.warranty.underWarranty === null || _vm.$store.state.form.warranty.underWarranty === true && _vm.$store.state.form.warranty.installationMonth === null || _vm.$store.state.form.warranty.underWarranty === true && _vm.$store.state.form.warranty.installationYear === null
    },
    on: {
      "click": function($event) {
        _vm.currentStep = 6;
        _vm.setPixel('Vedhæft filer')
      }
    }
  }, [_vm._v("\n                        Videre\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "line"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "right flex"
  }, [_c('button', {
    class: {
      'selected': _vm.$store.state.form.warranty.underWarranty === true
    },
    on: {
      "click": function($event) {
        _vm.$store.state.form.warranty.underWarranty = true
      }
    }
  }, [_vm._v("\n                            Ja\n                        ")]), _vm._v(" "), _c('button', {
    class: {
      'selected': _vm.$store.state.form.warranty.underWarranty === false
    },
    on: {
      "click": function($event) {
        _vm.$store.state.form.warranty.underWarranty = false
      }
    }
  }, [_vm._v("\n                            Nej\n                        ")])])]), _vm._v(" "), (_vm.$store.state.form.warranty.underWarranty === true) ? _c('div', {
    staticClass: "line"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "right flex"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.warranty.installationMonth),
      expression: "$store.state.form.warranty.installationMonth"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.$store.state.form.warranty, "installationMonth", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.months), function(month) {
    return _c('option', {
      key: month
    }, [_vm._v("\n                                " + _vm._s(month) + "\n                            ")])
  }), 0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.warranty.installationYear),
      expression: "$store.state.form.warranty.installationYear"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.$store.state.form.warranty, "installationYear", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.years), function(year) {
    return _c('option', {
      key: year
    }, [_vm._v("\n                                " + _vm._s(year) + "\n                            ")])
  }), 0)])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 6),
      expression: "currentStep === 6"
    }],
    staticClass: "step"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 5
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbage\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 7;
        _vm.setPixel('Kontaktinformationer')
      }
    }
  }, [_vm._v("\n                        Videre\n                        "), _c('i', {
    staticClass: "fal fa-chevron-right"
  })])])]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('file-upload', {
    attrs: {
      "intro": "Valgfrit - Upload billeder, video eller andre relevante filer, hvis du er blevet bedt om dette.<br><br><b style='font-family:AvenirHeavyOblique;'>OBS</b>&nbsp;&nbsp;Hvis din Quooker har mislyde, skal vi bede om en video<br><b style='font-family:AvenirHeavyOblique;color:#fff;'>OBS</b>&nbsp;&nbsp;Hvis din Quooker har fået en fysisk skade, skal vi bede om billeder",
      "singleFileUploaded": "fil uploadet",
      "multipleFilesUploaded": "filer uploadet",
      "noFilesUploaded": "Ingen filer uploadet",
      "addFilesButton": "Tilføj fil(er)",
      "remove": "Fjern"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === 7),
      expression: "currentStep === 7"
    }],
    staticClass: "step"
  }, [(_vm.currentStep === 7) ? _c('div', {
    staticStyle: {
      "display": "none",
      "position": "absolute",
      "z-index": "999",
      "background": "#f8f9fc",
      "width": "100%"
    },
    attrs: {
      "id": "emailMockup"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "100%",
      "width": "400px",
      "margin": "25px auto"
    }
  }, [_c('div', {
    staticClass: "intro"
  }, [_c('div', {
    staticStyle: {
      "white-space": "pre-wrap"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$store.state.texts.swedish)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Vigtigt!")]), _vm._v(" Har du spørgsmål bedes du besvare denne mail.\n                        "), _c('br'), _c('br'), _vm._v("\n                        Herunder finder du en kopi af dine indtastede oplysninger:\n                        "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "summary",
    staticStyle: {
      "background": "#fff",
      "padding": "30px",
      "border": "1px solid #ccc",
      "box-shadow": "0px 5px 15px rgba(0,0,0,0.15)"
    }
  }, [_c('div', [_c('b', [_vm._v("Sagsnummer")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.meta.id) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Beholder")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.form.container.serial !== null) ? _c('span', [_vm._v("\n                                " + _vm._s(_vm.$store.state.form.container.serial.toUpperCase()) + " - " + _vm._s(_vm.$store.state.form.validatedContainer.name) + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Hane")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.validatedFaucet.title) + "\n                            "), (_vm.$store.state.form.faucet.meta !== null) ? _c('span', [_vm._v("\n                                (" + _vm._s(_vm.$store.state.form.faucet.meta) + ")\n                            ")]) : _vm._e(), _vm._v(" "), _c('span', [_c('br'), _vm._v("\n                                " + _vm._s(_vm.$store.state.form.faucet.surface) + "\n                            ")]), _vm._v(" "), (_vm.$store.state.form.faucet.serial !== null) ? _c('span', [_c('br'), _vm._v("\n                                " + _vm._s(_vm.$store.state.form.faucet.serial) + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Spørgsmål")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.$store.state.form.problem.questions), function(q) {
    return _c('div', [_vm._v("\n                                " + _vm._s(q.question) + ":\n                                "), (q.answer) ? _c('b', [_vm._v("\n                                    Ja\n                                ")]) : _c('b', [_vm._v("Nej")]), _vm._v(" "), (q.extra) ? _c('b', [_vm._v("\n                                    (" + _vm._s(q.extra) + ")\n                                ")]) : _vm._e()])
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Beskrivelse af problemet")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.problem.description) + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Garanti")]), _vm._v(" "), _c('br'), _vm._v("\n                            Er produktet under 24 måneder?\n                            "), (_vm.$store.state.form.warranty.underWarranty) ? _c('b', [_vm._v("Ja")]) : _c('b', [_vm._v("Nej")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.form.warranty.underWarranty) ? _c('span', [_vm._v("\n                                Installationsdato:\n                                "), _c('b', [_vm._v(_vm._s(_vm.$store.state.form.warranty.installationMonth) + " " + _vm._s(_vm.$store.state.form.warranty.installationYear))])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Kontaktoplysninger")]), _vm._v(" "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.contact.firstname) + "\n                            " + _vm._s(_vm.$store.state.form.contact.lastname) + "\n                            "), _c('br'), _vm._v(" "), (_vm.$store.state.form.contact.company !== null) ? _c('span', [_vm._v("\n                                Firma: " + _vm._s(_vm.$store.state.form.contact.company) + "\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.form.contact.company !== null) ? _c('br') : _vm._e(), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.contact.phone) + "\n                            "), _c('br'), _vm._v("\n                            " + _vm._s(_vm.$store.state.form.contact.email) + "\n                            "), _c('br'), _vm._v(" "), (_vm.fullAddress !== null) ? _c('div', [_vm._v("\n                                " + _vm._s(_vm.fullAddress) + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Vedhæftninger")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.form.attachments.length > 0) ? _c('div', [_c('ul', _vm._l((_vm.$store.state.form.attachments), function(attachment) {
    return _c('li', {
      key: attachment.name
    }, [_c('a', {
      attrs: {
        "href": attachment.path
      }
    }, [_vm._v("\n                                            " + _vm._s(attachment.name) + "\n                                        ")])])
  }), 0)]) : _c('div', [_vm._v("\n                                Ingen filer uploadet\n                            ")])])]), _vm._v(" "), _vm._m(17)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "buttons__left"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.currentStep = 6
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-chevron-left"
  }), _vm._v("\n                        Tilbage\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "buttons__right"
  }, [(_vm.loading) ? _c('span', [_c('i', {
    staticClass: "fal fa-spinner fa-spin"
  }), _vm._v("\n                         \n                    ")]) : _vm._e(), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.loading || _vm.$v.$store.state.form.contact.$invalid || _vm.$store.state.form.terms.accepted === false
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("\n                        Send\n                        "), _c('i', {
    staticClass: "fal fa-envelope"
  })])])]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "line three-columns"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(19), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.firstname),
      expression: "$store.state.form.contact.firstname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "firstname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('validation-messages', {
    staticClass: "mts",
    attrs: {
      "data": _vm.$v.$store.state.form.contact.firstname
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "left middle"
  }, [_vm._m(20), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.lastname),
      expression: "$store.state.form.contact.lastname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "lastname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('validation-messages', {
    staticClass: "mts",
    attrs: {
      "data": _vm.$v.$store.state.form.contact.lastname
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Firma (valgfri)\n                        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.company),
      expression: "$store.state.form.contact.company"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "company", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._m(21), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.email),
      expression: "$store.state.form.contact.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('validation-messages', {
    staticClass: "mts",
    attrs: {
      "data": _vm.$v.$store.state.form.contact.email
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._m(22), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.contact.phone),
      expression: "$store.state.form.contact.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.$store.state.form.contact.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$store.state.form.contact, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('validation-messages', {
    staticClass: "mts",
    attrs: {
      "data": _vm.$v.$store.state.form.contact.phone
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "line address-field"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "calc(100% + 30px)"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-sm-6"
  }, [_vm._m(23), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "2f3b92h83nfuiei9he",
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-sm-2"
  }, [_vm._m(24), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zipcode),
      expression: "zipcode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.zipcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.zipcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-sm-4"
  }, [_vm._m(25), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city),
      expression: "city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.city = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(26)])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left fw terms"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.form.terms.accepted),
      expression: "$store.state.form.terms.accepted"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.$store.state.form.terms.accepted) ? _vm._i(_vm.$store.state.form.terms.accepted, null) > -1 : (_vm.$store.state.form.terms.accepted)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.$store.state.form.terms.accepted,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.$store.state.form.terms, "accepted", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.$store.state.form.terms, "accepted", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.$store.state.form.terms, "accepted", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(27)]), _vm._v(" "), _c('div', {
    staticClass: "right"
  })])])]), _vm._v(" "), (_vm.currentStep === 8) ? _c('div', {
    staticClass: "step"
  }, [_vm._m(28), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "font-size": "1.2em"
    }
  }, [_c('div', {
    staticStyle: {
      "white-space": "pre-wrap"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$store.state.texts.swedish)
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n                Sagsnummer: "), _c('b', [_vm._v(_vm._s(_vm.$store.state.form.meta.id))]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n                Vi har sendt dig en mail hvor dit sagsnummer også er noteret. Modtager du ikke denne email inden for en time, så tjek først din spam-mappe og kontakt os dernæst evt. telefonisk i stedet.\n            ")])]) : _vm._e()]), _vm._v(" "), (_vm.currentStep !== 7) ? _c('div', {
    staticClass: "q-progress-bar"
  }, [_c('div', {
    staticClass: "line",
    style: ('width:' + ((16.66 * _vm.currentStep) - 16.66) + '%;')
  }), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 1
    }
  }, [_vm._v("\n            1\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 2
    }
  }, [_vm._v("\n            2\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 3
    }
  }, [_vm._v("\n            3\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 4
    }
  }, [_vm._v("\n            4\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 5
    }
  }, [_vm._v("\n            5\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "q-progress-bar__step",
    class: {
      'active': _vm.currentStep === 6
    }
  }, [_vm._v("\n            6\n        ")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Kontaktformular (SE)\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                         \n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Her er der en beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                For at hjælpe dig bedst muligt, har vi brug for serienummeret på det produkt din henvendelse drejer sig om. Du skal som minimum altid indtaste serienummeret på din beholder, også selvom din henvendelse drejer sig om hanen, eller køleenheden.\n                "), _c('br'), _c('br'), _vm._v("\n                De fleste kunder vælger at indtaste serienumrene fra alle deres produkter, fordi man ved at gøre det, vil opnå den bedste, hurtigste og sikreste service fremover.\n                "), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Angiv serienummer\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        1 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Her er der en beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Serienummer på din beholder "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Serienummer på din hane "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Vælg hane\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        2 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Vælg overflade\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        3 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blink two"
  }, [_c('div', {
    staticClass: "blink__title"
  }, [_vm._v("\n                                    2 blink\n                                ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/gif/blinktwo.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blink four"
  }, [_c('div', {
    staticClass: "blink__title"
  }, [_vm._v("\n                                    4 blink\n                                ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/gif/blinkfour.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blink threeplusone"
  }, [_c('div', {
    staticClass: "blink__title"
  }, [_vm._v("\n                                    3 + 1 blink\n                                ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/gif/blinkthreeplusone.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Problem / årsag\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        4 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://quooker.dk/service/fejlguide/genstart-nulstil",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fal fa-video fa-fw"
  }), _vm._v("\n                                Sådan nulstiller du din Quooker\n                            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Beskrivelse af problemet\n                        ")]), _vm._v("\n                        Beskriv dit problem eller spørgsmål i feltet her. Ved fejl er det vigtigt at uddybe symptomet; Hvad gør du og hvad sker der?\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Garanti\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        5 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Er produktet under 24 måneder gammelt?\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('label', [_vm._v("\n                            Installationsdato\n                        ")]), _vm._v("\n                        Vælg måned og år din Quooker blev installeret\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Vedhæft filer\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        6 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outro",
    attrs: {
      "align": "center"
    }
  }, [_c('br'), _c('br'), _vm._v("\n                        Med venlig hilsen\n                        "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Quooker Skandinavien A/S")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        Kontaktinformationer\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step-counter"
  }, [_vm._v("\n                        7 / 7\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "step__description"
  }, [_vm._v("\n                    Step beskrivelse\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Fornavn "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Efternavn "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            E-mail "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Telefon "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                                Adresse "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                                Postnr. "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                                By "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "padding-top": "6px"
    }
  }, [_c('i', [_vm._v("Vi validerer ikke din adresse, sørg derfor for at indtaste din præcise adresse.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n                            Jeg har læst og accepterer Quookers "), _c('a', {
    attrs: {
      "href": "https://quooker.dk/privatlivspolitik",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_vm._v("privatlivs- og forretningsbetingelser")]), _vm._v(" "), _c('span', {
    staticClass: "red-star"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "step__title"
  }, [_c('div', [_vm._v("\n                        INDSENDT - Tak for din henvendelse\n                    ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55aec16a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/sweden.vue
// module id = 351
// module chunks = 1